import { render, staticRenderFns } from "./ChooseCoupon.vue?vue&type=template&id=98f29e3c&scoped=true"
import script from "./ChooseCoupon.vue?vue&type=script&lang=js"
export * from "./ChooseCoupon.vue?vue&type=script&lang=js"
import style0 from "./ChooseCoupon.vue?vue&type=style&index=0&id=98f29e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f29e3c",
  null
  
)

export default component.exports